import { OnlineEvaluationService } from "./../../../../../views/public/online-evaluation/online-evaluation.service";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { Component, OnInit, Input, ElementRef } from "@angular/core";
import { EvalDealerPersonalizationConfig, EvalDealerPersonalizationConfigUtils } from "@app/views/public/eval-dealer-personalization-model";
import { CreateOnlineEvaluationRequest } from "@app/views/public/online-evaluation/online-eval.model";

@Component({
  selector: "app-online-evaluation-header",
  templateUrl: "./online-evaluation-header.component.html",
  styleUrls: ["./online-evaluation-header.component.scss"],
})
export class OnlineEvaluationHeaderComponent implements OnInit {

  @Input() sellerDetails: EvalDealerPersonalizationConfig;
  createReq: CreateOnlineEvaluationRequest;
  
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private onlineService: OnlineEvaluationService, private elRef: ElementRef
  ) {}

  idEval: string;

  verifCode: string;

  ngOnInit() {}

  showBack(){
    if (this.router.url.indexOf("invite") >= 0 || this.router.url.indexOf("finalizado")) {
      return false;
    }
    return true;
  }

  back() {
    this.idEval = this.onlineService.idEval;
    this.verifCode = this.onlineService.verifCode;
    if (this.router.url.indexOf("ficha") >= 0) {
      this.router.navigate([
        `/online-eval/invite/${this.idEval}/${this.verifCode}`,
      ]);
    }
    if (this.router.url.indexOf("fotos") >= 0) {
      this.router.navigate([
        `/online-eval/ficha/${this.idEval}/${this.verifCode}`,
      ]);
    }
    if (this.router.url.indexOf("/eval") >= 0) {
      this.router.navigate([
        `/online-eval/fotos/${this.idEval}/${this.verifCode}`,
      ]);
    }

    if (this.router.url.indexOf("options") >= 0) {
      this.router.navigate([
        `/online-eval/eval/${this.idEval}/${this.verifCode}`,
      ]);
    }

    if (this.router.url.indexOf("finalizado") >= 0) {
      this.router.navigate([
        `/online-eval/resumo/${this.idEval}/${this.verifCode}`,
      ]);
    }

    if (this.router.url.indexOf("final") >= 0) {
      this.router.navigate([
        `/online-eval/options/${this.idEval}/${this.verifCode}`,
      ]);
    }

    if (this.router.url.indexOf("resumo") >= 0) {
      this.router.navigate([
        `/online-eval/final/${this.idEval}/${this.verifCode}`,
      ]);
    }
  }
}
